import { createContext, useContext, useState, useEffect } from 'react';

const SidebarContext = createContext();

const SIDEBAR_COLLAPSED_KEY = "sidebar_collapsed";

export function SidebarProvider({ children }) {
  const [isCollapsed, setIsCollapsed] = useState(() => {
    if (typeof window === 'undefined') return false;
    const saved = localStorage.getItem(SIDEBAR_COLLAPSED_KEY);
    if (saved !== null) {
      return JSON.parse(saved);
    }
    return window.innerWidth < 1400;
  });

  const toggleCollapsed = () => {
    const newState = !isCollapsed;
    setIsCollapsed(newState);
    localStorage.setItem(SIDEBAR_COLLAPSED_KEY, JSON.stringify(newState));
  };

  const setCollapsed = (value) => {
    setIsCollapsed(value);
    localStorage.setItem(SIDEBAR_COLLAPSED_KEY, JSON.stringify(value));
  };

  // Gestione resize per default collapsed su schermi piccoli (solo al primo caricamento)
  useEffect(() => {
    const handleResize = () => {
      const saved = localStorage.getItem(SIDEBAR_COLLAPSED_KEY);
      if (saved === null && window.innerWidth < 1400) {
        setIsCollapsed(true);
      }
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <SidebarContext.Provider value={{ isCollapsed, toggleCollapsed, setCollapsed }}>
      {children}
    </SidebarContext.Provider>
  );
}

export function useSidebar() {
  const context = useContext(SidebarContext);
  if (!context) {
    throw new Error('useSidebar must be used within a SidebarProvider');
  }
  return context;
}
